<div class="HomeSlider">
    <div class="slidesHolder" appMySwipe (mySwipeLeft)="onSwipeLeft($event)" (mySwipeRight)="onSwipeRight($event)">
        <div class="slides" #slides>
            <div class="slide" [class]="item.id" *ngFor="let item of data.slides; let i = index">
                <div class="bg slideBg">
                    <img [src]="!isMobile ? item.bg : item.bgMobile" alt="">
                    <video [src]="!isMobile? item.video : item.videoMob "
                        *ngIf="(!isMobile && item.video != '') || (isMobile && item.videoMob != '') " #videoEl
                        [poster]="!isMobile ? item.bg : item.bgMobile" [muted]="true" playsInline="true"
                        [autoplay]="true" [loop]="false" appVideoHandler (ended)="onVideoEnded($event)"
                        (timeupdate)="onVideoTimeUpdate($event, item)"></video>
                    <app-bg-slideshow
                        *ngIf="item.isSlideshow && item.slideshowItems?.length"
                        [items]="item.slideshowItems"
                        [isMobile]="isMobile"
                        [active]="i === selected"
                        [paused]="!bgVideoService.isPlaying"
                        (completed)="next()"
                        (labelChange)="currentLabel = $event">
                    </app-bg-slideshow>
                </div>

                <img class="fadeOverlay" src="assets/img/home-v2/homepage-main-promo-desktop-fade.png" alt="">

                <div class="videoLabel" *ngIf="i === selected && currentLabel" [innerHTML]="currentLabel | safeHtml"></div>

                <div class="ttHolder" *ngIf="!isMobile">
                    <div [class]=" 'ttWrapper ' + item.id">
                        <img [src]="item.tt" alt="" *ngIf="item.tt != ''">
                    </div>
                </div>

                <div class="contentWrapper" [class]="item.id" [ngClass]="{large: item.isLargeLogo}">
                    <div class="content" [ngClass]="{large: item.isLargeLogo}">

                        <div class="leftCol">
                            <!-- <div *ngIf="!isMobile" class="tag" [innerHTML]="item.tag | safeHtml"></div> -->
                            <a [routerLink]="item.button.url" class="logoLink">
                                <div class="logoHolder" [class]="item.id">
                                    <img [src]="item.logo" alt="" *ngIf="!item.isLargeLogo">
                                    <img [src]="item.largeLogo" alt="" *ngIf="item.isLargeLogo && !isMobile">
                                    <img [src]="item.logoMobile" alt="" *ngIf="item.isLargeLogo && isMobile">
                                </div>
                            </a>
                        </div>

                        <div class="rightCol">
                            <div *ngIf="!isMobile || item.isLargeLogo" class="description" [class]="item.id"
                                [innerHTML]="item.description | safeHtml" [ngStyle]="{color: item.descriptionColor}"></div>

                            <div class="buttons">
                                <a [routerLink]="item.button.url" class="button">
                                    <div class="bg" [ngStyle]="{backgroundColor: item.button.colorBG}"></div>
                                    <div class="label" [ngStyle]="{color: item.button.color}">
                                        <div class="icon">
                                            <svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="2" cy="4" r="2" fill="currentColor"/>
                                                <rect x="6" y="3" width="14" height="2" rx="1" fill="currentColor"/>
                                                <circle cx="2" cy="12" r="2" fill="currentColor"/>
                                                <rect x="6" y="11" width="14" height="2" rx="1" fill="currentColor"/>
                                            </svg>
                                        </div>
                                        <span [innerHTML]="item.button.label"></span>
                                    </div>
                                </a>

                                <a class="button" (click)="onOpenSizzleOverlay(item.button.url)"
                                    *ngIf="item.sizzleVideoLabel != ''">
                                    <div class="bg" [ngStyle]="{backgroundColor: item.button.colorBG}"></div>
                                    <div class="label" [ngStyle]="{color: item.button.color}">
                                        <div class="icon">
                                            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 5v14l11-7z"/>
                                            </svg>
                                        </div>
                                        <span [innerHTML]="item.sizzleVideoLabel"></span>
                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="playPauseButton">
        <app-video-mute-button *ngIf="!data.slides[selected]?.isSlideshow" [muted]="isMuted" (mutedChange)="onMuteToggle($event)"></app-video-mute-button>
        <app-video-play-pause-button [data]="videoEl?.toArray()[0]"></app-video-play-pause-button>
    </div>

    <div class="thumbsLabel">FAST Channels</div>
    <div class="thumbsWrapper">
        <div class="thumbs">
            <div class="thumb" *ngFor="let item of data.slides; let i=index">
                <div class="thumbHolder" (click)="onSelect(i)" [ngClass]="{selected: selected == i}">
                    <img [src]="!isMobile ? item.thumb : item.thumbMobile" alt="">
                </div>
            </div>
        </div>
    </div>
</div>
